import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import withResponsiveLayout from './withResponsiveLayout';
import OffersV4MobileLayout from './OffersV4MobileLayout';
import OffersV4DesktopLayout from './OffersV4DesktopLayout';
import OffersV4Confetti from './OffersV4Confetti';
import actionCreator from '../../redux/offer/action-creator';
import offerStateSelectors from '../../redux/offer/state-selectors';
import loanSelectors from '../../../../selectors/loan';
const { loanSelector } = loanSelectors;

const ResponsiveLayout = withResponsiveLayout(OffersV4MobileLayout, OffersV4DesktopLayout);

export class OffersV4LayoutComponent extends Component {
    static propTypes = {
        firstName: PropTypes.string,
        maxOffer: PropTypes.number.isRequired,
        minOffer: PropTypes.number,
        customizedOffer: PropTypes.number,
        sortedOffers: PropTypes.array,
        selectOffer: PropTypes.func.isRequired,
        isSelectingOffer: PropTypes.bool.isRequired,
        counterOffer: PropTypes.bool,
        counterOfferReportChanged: PropTypes.bool,
    };

    static defaultProps = {
        firstName: '',
        minOffer: 0,
        customizedOffer: 0,
        sortedOffers: [],
        isSelectingOffer: false,
        counterOffer: false,
        counterOfferReportChanged: false,
    };

    constructor(props) {
        super(props);
        const { selectedOffer, maxOffer, sortedOffers } = props;
        let sliderAmount = maxOffer;
        let selectedOfferId = null;

        if (selectedOffer && selectedOffer.amount && selectedOffer.duration) {
            const match = sortedOffers.find(o => o.amount === selectedOffer.amount && o.duration === selectedOffer.duration);
            if (match) {
                sliderAmount = match.amount;
                selectedOfferId = match.id;
            }
        }

        this.state = {
            sliderAmount,
            selectedOfferId,
            isDialogOpen: false,
        };
    }

    handleAmountChange = (amount) => {
        this.setState({ sliderAmount: amount, selectedOfferId: null });
    };

    handleEditClick = (e) => {
        this.openedViaKeyboard = e && e.detail === 0;
        this.triggerElement = document.activeElement;
        this.setState({ isDialogOpen: true });
    };

    handleDialogClose = () => {
        this.setState({ isDialogOpen: false });
        if (this.openedViaKeyboard && this.triggerElement && this.triggerElement.focus) {
            this.triggerElement.focus();
        }
    };

    handleDialogSubmit = (amount) => {
        this.handleAmountChange(amount);
        this.handleDialogClose();
    };

    handleCardSelect = (offerId) => {
        this.setState({ selectedOfferId: offerId });
    };

    handleContinue = () => {
        const { selectedOfferId } = this.state;
        if (selectedOfferId) {
            this.props.selectOffer(selectedOfferId);
        }
    };

    getOffersAtAmount(amount) {
        const { sortedOffers } = this.props;
        return sortedOffers
            .filter(offer => offer.amount === amount)
            .sort((a, b) => a.monthlyPayment - b.monthlyPayment);
    }

    getGuidanceTags(offersAtAmount) {
        if (offersAtAmount.length < 2) return {};

        let lowestAPR = offersAtAmount[0];
        let lowestPayment = offersAtAmount[0];

        for (let i = 1; i < offersAtAmount.length; i++) {
            if (offersAtAmount[i].annualPercentageRate < lowestAPR.annualPercentageRate) {
                lowestAPR = offersAtAmount[i];
            }
            if (offersAtAmount[i].monthlyPayment < lowestPayment.monthlyPayment) {
                lowestPayment = offersAtAmount[i];
            }
        }

        const tags = {};
        if (lowestAPR.id === lowestPayment.id) {
            tags[lowestAPR.id] = { label: 'Best Value', variant: 'success' };
        } else {
            tags[lowestAPR.id] = { label: 'Lowest APR', variant: 'information' };
            tags[lowestPayment.id] = { label: 'Lowest Monthly', variant: 'success' };
        }
        return tags;
    }

    render() {
        const { maxOffer, minOffer, isSelectingOffer, counterOffer, counterOfferReportChanged } = this.props;
        const { sliderAmount, selectedOfferId, isDialogOpen } = this.state;

        const offersAtAmount = this.getOffersAtAmount(sliderAmount);
        const guidanceTags = this.getGuidanceTags(offersAtAmount);

        return (
            <React.Fragment>
            <OffersV4Confetti />
            <ResponsiveLayout
                maxOffer={maxOffer}
                minOffer={minOffer}
                sliderAmount={sliderAmount}
                selectedOfferId={selectedOfferId}
                isSelectingOffer={isSelectingOffer}
                offersAtAmount={offersAtAmount}
                guidanceTags={guidanceTags}
                isDialogOpen={isDialogOpen}
                counterOffer={counterOffer}
                counterOfferReportChanged={counterOfferReportChanged}
                onAmountChange={this.handleAmountChange}
                onCardSelect={this.handleCardSelect}
                onContinue={this.handleContinue}
                onEditClick={this.handleEditClick}
                onDialogClose={this.handleDialogClose}
                onDialogSubmit={this.handleDialogSubmit}
            />
            </React.Fragment>
        );
    }
}

const mapStateToProps = (state, props) => {
    const { offersPage = {} } = state;
    const { offers = {} } = offersPage;
    const { sortedOffers = [] } = offers;
    const isSelectingOffer = offerStateSelectors.getOfferSelecting(state);
    const selectedOffer = loanSelector.getSelectedOffer(state);

    return {
        ...props,
        sortedOffers,
        selectedOffer,
        isSelectingOffer: isSelectingOffer ? true : false,
    };
};

const mapDispatchToProps = (dispatch) => ({
    selectOffer: (offerId) => dispatch((_, getState) => {
        const state = getState();
        if (state && state.loan && state.loan.loanJson && state.loan.loanJson.loanId) {
            dispatch(actionCreator.selectOfferAuthenticated(offerId, state.loan.loanJson.loanId));
        } else {
            dispatch(actionCreator.selectOffer(offerId));
        }
    }),
});

export const OffersV4Layout = connect(
    mapStateToProps,
    mapDispatchToProps
)(OffersV4LayoutComponent);

export default OffersV4Layout;
